export const EntityTypes = ['item', 'property', 'lexeme', 'form', 'sense'];
//# sourceMappingURL=entity.js.map